import styled from 'styled-components';

const ProtectMask = styled.div`
    position: absolute;
    display: block;
    background-color: transparent;
    width: 100%;
    height: 100%;
    z-index: 1;
    top: 0;
    left: 0;
`;

export default ProtectMask;
